import { DashboardJobsType, IDashboardJob } from '~/domain/DashboardJobs';
import { useUserSelector } from '~/hooks/useUserSelector';
import { trackEvent } from '../../../../../api/analytics';
import history from '../../../../../history';
import { headerOpenTabTitles } from '../../utils';
import { CustomTable } from '../CustomTable';
import { renderRow } from './renderRow';

export const OpenTabLegacy = () => {
  const user = useUserSelector();

  const handleOnClick = (item: IDashboardJob) => {
    trackEvent('Shifts - Open Shifts Tab - Shift Tile Clicked', {
      shiftId: item?.id,
      shiftSpecialty: item?.specialty,
      procedures: item?.procedures,
      breakTime: item?.lunchBreakTime,
      autoConfirm: item?.autoFill,
      softwares: user?.office_info?.softwares,
      assistedHygiene: item?.isAssistedHygiene,
      tpp: item?.amount,
    });

    history.push(`/dashboard/job/${item.id}`);
  };

  return (
    <CustomTable
      type={DashboardJobsType.OPEN}
      renderRow={(item) => renderRow({ item, handleOnClick })}
      headerTitles={headerOpenTabTitles}
      onRowClick={(item) => handleOnClick(item)}
    />
  );
};
